import { useCallback } from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import {
  setReplenishmentNotifications,
  toggleReplenishmentNotificationsModal
} from '../actions';
import { readNotification } from '../api/mutations';
import {
  CompanyNotification,
  ReadNotificationMutation,
  ReadNotificationMutationVariables
} from '../graphql/graphql';
import { removeBusinessNotificationFromCache } from '../utils/helpers/removeBusinessNotificationFromCache';

export const useCloseReplenishmentNotification = (
  profileId: string | undefined,
  notifications: CompanyNotification[] | undefined
) => {
  const dispatch = useDispatch();
  const client = useApolloClient();
  const [readBusinessNotification] = useMutation<
    ReadNotificationMutation,
    ReadNotificationMutationVariables
  >(readNotification);

  return useCallback(() => {
    const notification = notifications?.[0];

    dispatch(toggleReplenishmentNotificationsModal(false));

    if (!notification) return;

    readBusinessNotification({
      variables: { id: notification.id }
    }).then(({ data }) => {
      if (!data?.readNotification || data.readNotification.errors.length) {
        return;
      }

      const updatedNotifications =
        (notifications || [])?.filter(({ id }) => id !== notification.id) ?? [];

      dispatch(setReplenishmentNotifications(updatedNotifications));
      removeBusinessNotificationFromCache(profileId, notification.id, client);
    });
  }, [client, dispatch, notifications, profileId, readBusinessNotification]);
};
